export const changestartDateReducer = (state = null, action) => {
    switch (action.type) {
      case "CHANGE_START_DATE":
        return action.payload.startDate;
      default:
        return state;
    }
  };
  